import { Box, Icon, Typography } from '@mui/material'
import AdxPopper from 'components/reusable/AdxPopper'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import DashboardContainer from 'components/smart/dashboard-container/DashboardContainer'
import React, { useEffect, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { useLocation, useNavigate } from 'react-router-dom'
import { cancelAppraisal, getAppraisal } from 'services/api/modules/performance/appraisal/appraisal'
import ACDActionButton from '../components/ACDActionButton'
import ACDTabs from '../components/ACDTabs'

const AppraisalCycleDetails = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const queryClient = useQueryClient()
  const [appraisal, setAppraisal] = useState([])
  useEffect(() => {
    queryClient.invalidateQueries('appraisalData')
    queryClient.resetQueries('appraisalData')
  }, [])

  const { isLoading, error, data } = useQuery(['appraisalData', location.state.id], async () => {
    const { data } = await getAppraisal(location.state.id)
    setAppraisal(data ?? [])
  })

  const handleBack = () => {
    navigate(`/app/appraisal-cycle`, {
      state: { mainAppraisalTabsValue: location.state.mainAppraisalTabsValue },
    })
  }

  const formatCourseDate = (date) => {
    const dateObj = new Date(date + 'T00:00:00')
    return new Intl.DateTimeFormat('en-GB').format(dateObj)
  }

  const handleManage = (appraisalId) => {
    navigate(`/app/appraisal-cycle/${appraisalId}/manage`, {
      state: { ...location.state, mainAppraisalTabsValue: location.state.mainAppraisalTabsValue },
    })
  }

  // Cancel button =================================================================
  const [isModalOpen, setModalOpen] = useState(false)

  const handleOpen = () => {
    setModalOpen(true)
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  const { mutate } = useMutation((id) => cancelAppraisal(id), {
    onSuccess: async () => {
      navigate('/app/appraisal-cycle', {
        state: { mainAppraisalTabsValue: location.state.mainAppraisalTabsValue },
      })
    },
  })

  const handleConfirm = () => {
    mutate(location.state.id)
  }
  // Cancel button =================================================================

  return (
    <DashboardContainer
      headerTitle={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Typography onClick={handleBack} sx={{ cursor: 'pointer', color: 'alternate.main' }}>
            Appraisal
          </Typography>
          <Icon sx={{ fontSize: 20, color: 'light-gray-text.main' }}>chevron_right</Icon>
          <Typography sx={{ color: 'light-gray-text.main', textTransform: 'capitalize' }}>
            {appraisal?.label}
          </Typography>
        </Box>
      }
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <ACDActionButton
          title={appraisal?.label}
          status_name={appraisal?.status_name}
          start_date={appraisal?.start_date && formatCourseDate(appraisal?.start_date)}
          end_date={appraisal?.due_date && formatCourseDate(appraisal?.due_date)}
          nav={
            <AdxPopper placement="bottom-end" sx={{ marginTop: 1 }}>
              {appraisal?.status_name === 'Scheduled' && (
                <Typography
                  onClick={() => handleManage(appraisal?.id)}
                  sx={{ color: 'alternate.main' }}
                >
                  Manage
                </Typography>
              )}
              <Typography sx={{ color: 'error.main' }} onClick={handleOpen}>
                Cancel
              </Typography>
            </AdxPopper>
          }
          isLoading={isLoading}
        />
        <ACDTabs
          cycleName={appraisal?.label}
          status_name={appraisal?.status_name}
          start_date={appraisal?.start_date && formatCourseDate(appraisal?.start_date)}
          end_date={appraisal?.due_date && formatCourseDate(appraisal?.due_date)}
          description={appraisal?.description}
          isLoading={isLoading}
          totalEvaluations={appraisal?.total_evaluation}
          totalParticipants={appraisal?.total_participants}
        />
      </Box>
      <AdxInfoModal
        variant={'warning'}
        open={isModalOpen}
        onClose={handleClose}
        muiIcon="warning"
        iconColor="error.main"
        title="Do you want to cancel this appraisal?"
        subtitle="Any unsaved changes will be discarded"
        footerButtons
        firstBtnLabel={'Confirm'}
        firstBtnHandle={handleConfirm}
        secondBtnLabel={'Close'}
        secondBtnHandle={handleClose}
      />
    </DashboardContainer>
  )
}

export default AppraisalCycleDetails
